import { Avatar, Tooltip } from 'antd';
import { sortBy } from 'lodash';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ProjectId } from 'api/models';
import { Avatar as StyledAvatar } from 'components/atoms/avatar';
import { AvatarGroupSkeleton } from 'components/atoms/custom-skeletons';
import { Loading } from 'components/atoms/loading';
import { useMemberships } from 'hooks/use-memberships';
import { getUserLabel } from 'utils/get-user-label';
import { useActiveProjectConversation } from '../../proj-conversation-hooks';
import { InviteMembersModal } from './invite-members-modal';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: var(--spacing-05);
  cursor: pointer;
`;

const RemainingMembers = styled(Avatar)`
  color: var(--white-100);
`;

export const ChannelMembers: FC<{ projectId: ProjectId }> = ({ projectId }) => {
  const [showInvitePopup, setshowInvitePopup] = useState(false);
  const [status] = useMemberships(projectId);
  const activeConversation = useActiveProjectConversation();

  if (status === 'loading' || !activeConversation) {
    return (
      <Container>
        <Loading />
      </Container>
    );
  }
  const { members = [] } = activeConversation;
  const sortedMembers = sortBy(members, ['userId', 'photoUrl']);

  return (
    <>
      {members.length === 0 ? (
        <Container>
          <AvatarGroupSkeleton size="small" />
        </Container>
      ) : null}
      <Container onClick={() => setshowInvitePopup(true)}>
        <Avatar.Group>
          {members.length > 2 ? (
            <>
              {sortedMembers.slice(0, 2).map(({ user }) => (
                <StyledAvatar
                  src={user.photoUrl}
                  name={getUserLabel(user)}
                  key={user.userId}
                />
              ))}
              <Tooltip
                title={
                  <FormattedMessage
                    id="view_all_n_members"
                    values={{
                      count: members.length,
                    }}
                  />
                }
                placement="top"
              >
                <RemainingMembers>
                  <FormattedMessage
                    id="more_members_count"
                    values={{
                      count: members.length - 2,
                    }}
                  />
                </RemainingMembers>
              </Tooltip>
            </>
          ) : (
            sortedMembers.map(({ user }) => (
              <StyledAvatar
                src={user.photoUrl}
                name={getUserLabel(user)}
                key={user.userId}
              />
            ))
          )}
        </Avatar.Group>
      </Container>

      {showInvitePopup && (
        <InviteMembersModal
          visible={showInvitePopup}
          handleOnClose={setshowInvitePopup}
          projectId={projectId}
        />
      )}
    </>
  );
};
